import { formatOrderCreator } from "./index";

export const convertOrderStatus = (status) => {
    let title = "-"
    switch (status) {
        case "CREATED":
            title = "ອໍເດີ້ເຂົ້າ"
            break;
        case "READY_TO_SHIPPING":
        case "READYTOSHIPPING":
            title = "ອໍເດີພ້ອມສົ່ງ"
            break;
        case "SHIPPING":
            title = "ອໍເດີຢູ່ໃນລະຫວ່າງຈັດສົ່ງ"
            break;
        case "SHIPPINGCOMPLETED":
        case "SHIPPING_COMPLETED":
            title = "ສົ່ງສໍາເລັດ"
            break;
        case "COMPLETED":
            title = "ອໍເດີ້ສໍາເລັດ"
            break;
        case "CANCELLED":
            title = "ຍົກເລີກ"
            break;
        case "USERCONFIRM":
            title = "ກວດສອບແລ້ວ"
            break;
        case "IMAGE_NOT_YET_PAID":
            title = "ແຈ້ງຍອດແຕ່ບໍໂອນ"
            break;
        case "PAYMENT_STILL_INCOMPLETE":
            title = "ຍອດເງິນບໍຖຶກຕ້ອງ"
            break;
        case "WAITINGCONFIRM":
            title = "ລໍຖ້າຢືນຢັນ"
            break;
        case "PRINT_ORDER":
            title = "ພີມບິນແລ້ວ"
            break; 
        case "PAYMENT_PROCESSING":
            title = "ກຳລັງລໍຖ້າຊຳລະເງິນ"
            break; 
        case "SHIPPING_COMPLETED":
            title = "ສົ່ງສຳເລັດ"
            break; 
        case "CART":
            title = "ກະຕ່າກຽມແພັກ"
            break;
        case "REJECT":
            title = "ປະຕິເສດ"
            break;
        default:
            title = ""
            break;
    }
    return title
}

export const revertOrderStatus = (status) => {
    let title = "-"
    switch (status) {
        case "ອໍເດີ້ສໍາເລັດ":
            title = "CREATED"
            break;
        case "ກະກຽມຈັດສົ່ງ":
            title = "READYTOSHIP"
            break;
        case "ກໍາລັງສົ່ງ":
            title = "SHIPPING"
            break;
        case "ສົ່ງສໍາເລັດ":
            title = "SHIPPING_COMPLETED"
            break;
        case "ສໍາເລັດບໍລິການ":
            title = "COMPLETED"
            break;
        case "ຍົກເລີກ":
            title = "CANCELLED"
            break;
        case "ລູກຄ້າຢືນຢັນ":
            title = "USERCONFIRM"
            break;
        default:
            title = "CREATED"
            break;
    }
    return title
}


//* ອໍເດີ້ມາຈາກໃຜ: ພະນັກງານ/ແອັດມິນທີ່ສ້າງ (ອໍເດີ້ສ້າງເອງ, POS) — ອໍເດີ້ຈາກລູກຄ້າ (ໄລຟ, ໂພສ, ເຊວເພຈ)
//* ບໍ່ມີຜູ້ສ້າງໃນຮ້ານ → ສະແດງຊ່ອງທາງແທນ
export const getOrderSourceLabel = (order) =>
  formatOrderCreator(order?.creator) || convertOrderType(order?.type);

export const convertOrderType = (status) => {
    let title = "-"
    switch (status) {
        case "LIVE":
            title = "ໄລຟ"
            break;
        case "POST":
            title = "ໂພສ"
            break;
        case "KEY_IN":
            title = "ສ້າງເອງ"
            break;
        case "E_COMMERCE":
            title = "ຈາກແອັບ"
            break;
        case "POS":
            title = "POS"
            break;
        case "SALE_PAGE":
                title = "ເຊວເພຈ"
                break;
        case "SALE_PAGE_AFFILIATE":
                title = "ອາຟຣິລີເອດ"
                break;
        default:
            title = "ໄລຟ"
            break;
    }
    return title
}

export const convertPayment = (payment) => {
    let title = "-"
    switch (payment) {
        case "COD":
            title = "COD"
            break;
        case "TRANSFER":
            title = "ເງີນໂອນ"
            break;
        case "CASH":
            title = "ເງີນສົດ"
            break;
        case "OTHER":
            title = "ອື່ນໆ"
            break;
        default:
            title = "ເງີນໂອນ"
            break;
    }
    return title
}